import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKETS]: {
		url: '/company/:companyId/weighing/combiner_tickets/',
	},
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET]: {
		url: '/company/:companyId/weighing/combiner_tickets/:combinerTicketId/',
	},
	[ModulesConfigMap[ModulesMap.WEIGHING_COMBINER_TICKETS].GET_WEIGHING_COMBINER_TICKET_PREVIEW]: {
		url: '/company/:companyId/weighing/combiner_tickets/:combinerTicketId/preview/',
	},
}
